/**
 * POPPHIN Ocean Match — brand constants.
 * Per CSTS §5: never hardcode brand strings elsewhere; always import from here.
 *
 * Ships under the Popphin Learning imprint. Full imprint registry lives at
 * Cinderpoint/All/imprints.json (imprint_id = "popphin_learning").
 *
 * When USPTO registers the mark (SOU accepted, expected Q4 2026), flip TM → R in ONE line
 * and the whole product updates.
 */

export const TRADEMARK_WORDMARK = "POPPHIN™";
export const TRADEMARK_SERIAL = "99269472";
export const TRADEMARK_STATUS = "application pending";

export const IMPRINT = "Popphin Learning";
// IMPRINT_DOMAIN removed — read from config/game_info.json (imprintDomain field).
export const IMPRINT_ATTRIBUTION = "A Popphin Learning game";

export const LEGAL_OWNER = "Cinderpoint Systems LLC";
export const LEGAL_YEAR = "2026";

export const TRADEMARK_LEGAL_NOTICE =
  `${TRADEMARK_WORDMARK} is a trademark of ${LEGAL_OWNER}. ` +
  `USPTO Serial ${TRADEMARK_SERIAL}, ${TRADEMARK_STATUS}.`;

export const COPYRIGHT_LINE =
  `Copyright ${LEGAL_YEAR} ${LEGAL_OWNER}. All rights reserved.`;

export const CREDIT_LINES = [
  `${TRADEMARK_WORDMARK} Ocean Match`,
  IMPRINT_ATTRIBUTION,
  COPYRIGHT_LINE,
  TRADEMARK_LEGAL_NOTICE
] as const;
